import { render, staticRenderFns } from "./scene-zone.vue?vue&type=template&id=4b1d03dd&scoped=true&"
import script from "./scene-zone.vue?vue&type=script&lang=js&"
export * from "./scene-zone.vue?vue&type=script&lang=js&"
import style0 from "./scene-zone.vue?vue&type=style&index=0&id=4b1d03dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1d03dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fcs/fcs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b1d03dd')) {
      api.createRecord('4b1d03dd', component.options)
    } else {
      api.reload('4b1d03dd', component.options)
    }
    module.hot.accept("./scene-zone.vue?vue&type=template&id=4b1d03dd&scoped=true&", function () {
      api.rerender('4b1d03dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scene-zone.vue"
export default component.exports